module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Wood1-907e9124a39127c56b1d2db36275674b.svg";